package com.upcominds.expedite.data.energy

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.dto.CommunityEnergyDTO
import com.upcominds.expedite.dto.CommunityEnergyConnectionRequest
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.ContentType
import io.ktor.http.contentType

class CommunityEnergyRepository {
    suspend fun getMemberEnergy(id: String): CommunityEnergyDTO = NetworkClient.httpClient
        .get(NetworkClient.endpoint("api/communities/$id/energy")).body()

    suspend fun getAdminEnergy(id: String): CommunityEnergyDTO = NetworkClient.httpClient
        .get(NetworkClient.endpoint("api/admin/communities/$id/energy")).body()

    suspend fun connect(id: String, name: String?): CommunityEnergyDTO = NetworkClient.httpClient
        .put(NetworkClient.endpoint("api/admin/communities/$id/energy")) {
            contentType(ContentType.Application.Json)
            setBody(CommunityEnergyConnectionRequest(name))
        }.body()

    suspend fun sync(id: String): CommunityEnergyDTO = NetworkClient.httpClient
        .post(NetworkClient.endpoint("api/admin/communities/$id/energy/sync")).body()
}
